<script>
import { authService } from '@/src/services/safehaven/AuthService'

export default {
  data() {
    return {
      org: null,
    }
  },
  mounted() {
    // console.log(this.$route);
    this.getOrgDetails()
  },
  methods: {
    getOrgDetails() {
      const orgName = this.$route.params.clientId.toLowerCase()
      authService.getLogo(orgName).then((res) => {
        this.org = res.data
        localStorage.setItem('organisationDetails', JSON.stringify(res.data))
      })
    },
  },
}
</script>

<template>
  <v-container
    v-if="$route.name !== 'admin-home'"
    id="safehaven"
    fluid
    :class="$style.container"
    fill-height
  >
    <div :class="$style.innerContainer">
      <div v-if="org" class="mt-10" align="center">
        <img :class="$style.logo" :src="org.logo_url" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </v-container>
  <v-container v-else>
    <div :class="$style.container">
      <slot />
    </div>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}

.innerContainer {
  width: 32%;
  margin: auto;
  background-color: white;
  border-radius: 9px;
}

.logo {
  width: 85%;
  height: auto;
}
</style>
